import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useUpdateSociogramCourseTeacherAccess = (options = {}) => {
  const mutation = useApiMutation(
    'schools',
    ({ courseId }) =>
      `/current-organization/current-term/sociogram-courses/${courseId}/teacher-access`,
    'post',
    options,
    { authenticated: true, version: 5 }
  )

  return {
    isUpdatingAccess: mutation.isPending,
    errorUpdatingAccess: mutation.error ?? null,
    updateCourseTeacherAccess: ({ courseId, hasAccess, eventId }) =>
      mutation.mutateAsync({
        courseId,
        data: { hasAccess, eventId }
      })
  }
}
